import React, { ReactNode } from 'react';

import * as S from './SingleWidget.styles';

interface SingleWidgetProps {
  HeaderElement?: ReactNode;
  ContentElement?: ReactNode;
  FooterElement?: ReactNode;
}

export const SingleWidget: React.FunctionComponent<SingleWidgetProps> = ({
  HeaderElement,
  ContentElement,
  FooterElement,
}) => {
  return (
    <S.WidgetSection aria-labelledby="widget-section">
      <S.Header>{HeaderElement}</S.Header>
      <S.Content>{ContentElement}</S.Content>
      <S.Footer>{FooterElement}</S.Footer>
    </S.WidgetSection>
  );
};
